export const THEME_LOOKUPS_RESOURCE = 'themeLookups';
export const THEME_LOOKUP_RESOURCE = 'themeLookup';
export const CREATE_THEME_LOOKUP_RESOURCE = 'createThemeLookup';
export const UPDATE_THEME_LOOKUP_RESOURCE = 'updateThemeLookup';
export const REMOVE_THEME_LOOKUP_RESOURCE = 'removeThemeLookup';

export const INFINITE_SCROLL = { loader: 'blocked' };
export const ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
};
